import { downloadFile } from '@seiue/util'
import { FC, useContext, useEffect, useRef } from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { TaskCompletedDetail } from 'packages/sdks-next/growp'

import { getTheme } from '@/utils/theme'

import { CourseContext } from '../../context'
import { useUpdateOutlineComplete } from '../../utils'

/**
 * 视频内容
 *
 * @param param0 - 参数
 * @param param0.url - 视频地址
 * @param param0.curCompletedDetail - 当前大纲完成详情
 * @returns 视频内容
 */
export const VideoContent: FC<{
  url: string
  curCompletedDetail: TaskCompletedDetail | undefined
}> = ({ url, curCompletedDetail }) => {
  const theme = getTheme()
  const { currentOutline, isPreview } = useContext(CourseContext)
  const videoRef = useRef<HTMLDivElement>(null)

  const updateOutlineComplete = useUpdateOutlineComplete()

  useEffect(() => {
    const video = videoRef.current
    if (video) {
      video.addEventListener('contextmenu', forbidContextMenu)
    }
    return () => {
      video && video.removeEventListener('contextmenu', forbidContextMenu)
    }
  }, [videoRef.current])

  const forbidContextMenu = (e: MouseEvent) => {
    e.preventDefault()
    return false
  }

  const videoInfo = currentOutline?.attachments?.length
    ? currentOutline?.attachments[0]
    : {
        name: '',
        url: '',
      }

  return (
    <Wrapper>
      <PlayerWrapper ref={videoRef}>
        <ReactPlayer
          url={url}
          controls={true}
          width="100%"
          height="100%"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload', // 可选属性，禁用下载按钮
              },
            },
          }}
          onPlay={async () => {
            if (
              !isPreview &&
              currentOutline?.id &&
              (!curCompletedDetail?.isViewed ||
                !curCompletedDetail?.isCompleted)
            ) {
              await updateOutlineComplete({
                taskId: currentOutline?.id,
                id: currentOutline.parentId || 0,
                payload: { isCompleted: true, isViewed: true },
              })
            }
          }}
        />
      </PlayerWrapper>
      <Footer>
        <MainFooter>
          <Title>{currentOutline?.name || '-'}</Title>
          {currentOutline?.allowAttachmentDown ? (
            <DownloadBtn
              onClick={() => downloadFile(videoInfo.name, videoInfo.url)}
            >
              <GrowpIcon
                name="Download"
                text="下载"
                size={14}
                hoverColor={theme.brand._1}
              />
            </DownloadBtn>
          ) : null}
        </MainFooter>
      </Footer>
    </Wrapper>
  )
}

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${(props) => props.theme.text._1};
`
const Wrapper = styled.div``
const Footer = styled.div`
  padding: 20px;
`

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
`

const MainFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 0 0;
  border-top: 1px solid ${(props) => props.theme.border.greyNormal};
`

const DownloadBtn = styled.div`
  cursor: pointer;
`
